import { render, staticRenderFns } from "./Break.vue?vue&type=template&id=6dba1742&scoped=true&"
import script from "./Break.vue?vue&type=script&lang=js&"
export * from "./Break.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dba1742",
  null
  
)

export default component.exports